// extracted by mini-css-extract-plugin
export var headerXL = "SectionContent-module--headerXL--2bQkD";
export var headerL = "SectionContent-module--headerL--2oJiy";
export var headerM = "SectionContent-module--headerM--20VTh";
export var headerS = "SectionContent-module--headerS--1f4wQ";
export var headerXS = "SectionContent-module--headerXS--SlVzW";
export var blogHeaderXL = "SectionContent-module--blogHeaderXL--2sfjp";
export var blogHeaderL = "SectionContent-module--blogHeaderL--2dCGJ";
export var blogHeaderM = "SectionContent-module--blogHeaderM--RVeTO";
export var blogHeaderS = "SectionContent-module--blogHeaderS--2pNmb";
export var blogHeaderXS = "SectionContent-module--blogHeaderXS--3YFbK";
export var headerPreamble = "SectionContent-module--headerPreamble--3NRCE";
export var preHeader = "SectionContent-module--preHeader--30wap";
export var textNormal = "SectionContent-module--textNormal--2Y8qk";
export var textSmall = "SectionContent-module--textSmall--TiQt7";
export var textSmallAlternate = "SectionContent-module--textSmallAlternate--1fb6K";
export var legend = "SectionContent-module--legend--puIqz";
export var caption = "SectionContent-module--caption--pqn8Z";
export var gradientBackground = "SectionContent-module--gradientBackground--2YqtM";
export var ellipsis = "SectionContent-module--ellipsis--1U7aQ";
export var globalContainer = "SectionContent-module--globalContainer--2-P6k";
export var maxWidth = "SectionContent-module--maxWidth--19u3y";
export var clipBottom = "SectionContent-module--clipBottom--2jmdf";
export var clipTopBottom = "SectionContent-module--clipTopBottom--3l_Ld";
export var sectionContent = "SectionContent-module--sectionContent--2EcK1";
export var container = "SectionContent-module--container--30nl9";
export var hasCubes = "SectionContent-module--hasCubes--1OdwO";
export var isHero = "SectionContent-module--isHero--1Il0K";
export var inverseSection = "SectionContent-module--inverseSection--3K-Cc";
export var content = "SectionContent-module--content--27uH3";
export var hasIllustration = "SectionContent-module--hasIllustration--3Bbbg";
export var preTitle = "SectionContent-module--preTitle--124Di";
export var buttonsContainer = "SectionContent-module--buttonsContainer--XnhuS";
export var fullWidthButton = "SectionContent-module--fullWidthButton--Sgh54";
export var contentBody = "SectionContent-module--contentBody--3jygC";
export var cubes = "SectionContent-module--cubes--2GDcN";
export var floatingWhite = "SectionContent-module--floatingWhite--2xO0l";
export var rightOfContent = "SectionContent-module--rightOfContent--2L3js";
export var leftOfContent = "SectionContent-module--leftOfContent--1i0q1";
export var rightOfIllustration = "SectionContent-module--rightOfIllustration--2eRLv";
export var transparentBlue = "SectionContent-module--transparentBlue--e9R_r";
export var customIllustration = "SectionContent-module--customIllustration--39pPa";
export var ch2 = "SectionContent-module--ch2--4i7Bj";
export var ch2Container = "SectionContent-module--ch2-container--2r8C9";